import Vue from 'vue';
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Top from '../components/Top';
import Login from '../components/Login';
import PrivatePolicy from '../components/PrivatePolicy';
import TermsOfService from '../components/TermsOfService';

const routes = [
    { path: '/', component: Top },
    { path: '/login', component: Login },
    { path: '/privatepolicy', component: PrivatePolicy },
    { path: '/termsofservice', component: TermsOfService }
]

export default new VueRouter({
    routes
});
